/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticationGuard} from "@pitagon/ngx-pids/security";
import {QuicklinkModule, QuicklinkStrategy} from "ngx-quicklink";
import {AppLayoutComponent} from "./app-layout";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('src/@pitagon/ngx-pids/pages/src/auth/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('src/app/pages/apps/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('src/app/pages/apps/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
    path: 'coming-soon',
    loadChildren: () => import('src/demo/pages/pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule),
  },
  {
    path: '',
    component: AppLayoutComponent,
    // canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: '',
        loadChildren: () => import('src/demo/pages/dashboards/dashboard-analytics/dashboard-analytics.module').then(m => m.DashboardAnalyticsModule),
      },
      {
        path: 'apps',
        children: [
          {
            path: 'settings',
            loadChildren: () => import('src/app/pages/apps/settings/settings.module').then(m => m.SettingsModule),
          },{
            path: 'menus',
            loadChildren: () => import('src/app/pages/apps/menu/menu.module').then(m => m.MenuModule)
          },
          {
            path: 'roles',
            loadChildren: () => import('src/app/pages/apps/role/role.module').then(m => m.RoleModule)
          },
          {
            path: 'com-cats',
            loadChildren: () => import('src/app/pages/apps/com-cat/com-cat.module').then(m => m.ComCatModule)
          },
          {
            path: 'monitoring',
            loadChildren: () => import('src/app/pages/apps/monitoring/monitoring.module').then(m => m.MonitoringModule)
          },
          {
            path: 'device-monitoring',
            loadChildren: () => import('src/app/pages/apps/device-monitoring/device-monitoring.module').then(m => m.DeviceMonitoringModule)
          },
          {
            path: 'device-model-monitoring',
            loadChildren: () => import('src/app/pages/apps/device-model-monitoring/device-model-monitoring.module').then(m => m.DeviceModelMonitoringModule)
          },{
            path: 'activity-log',
            loadChildren: () => import('src/app/pages/apps/activity-log/activity-log.module').then(m => m.ActivityLogModule)
          },
          {
            path: 'human-resource',
            loadChildren: () => import('src/app/pages/apps/human-resource/human-resource.module').then(m => m.HumanResourceModule)
          },
          {
            path: 'tenant-management',
            loadChildren: () => import('src/app/pages/apps/tenant-management/tenant-management.module').then(m => m.TenantManagementModule)
          },
          {
            path: 'management/users',
            loadChildren: () => import('src/app/pages/apps/management/users/users.module').then(m => m.UsersModule)
          },
          // {
          //   path: 'new-role',
          //   loadChildren: () => import('src/app/pages/apps/new-role/new-role.module').then(m => m.NewRoleModule)
          // },
          {
            path: 'vehicle',
            loadChildren: () => import('src/app/pages/apps/vehicle/vehicle.module').then(m => m.VehicleModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'water-resource',
            loadChildren: () => import('src/app/pages/apps/water-resource/water-resource.module').then(m => m.WaterResourceModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'incident-management',
            loadChildren: () => import('src/app/pages/apps/incident-management/incident-management.module').then(m => m.IncidentManagementModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
        ]
      },
      {
        path: '**',
        loadChildren: () => import('src/demo/pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule, QuicklinkModule]
})
export class AppRoutingModule {
}
